import styled from "styled-components";

export const StyledDatepicker = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  .react-date-picker__inputGroup__input {
    padding: 0 1px !important;
  }
  .react-date-picker__inputGroup__input--hasLeadingZero {
    padding-left: calc(1px + 0.54em) !important;
  }
  .react-date-picker__wrapper {
    border: none;
   ${({ error, theme }) => error === true ? ` border-bottom: 1px solid ${theme.input.errorColor};` : ` border-bottom: 1px solid ${theme.overlay.underline};`};
    cursor: pointer;
    input, span {
      color: inherit;
    }
    button {
      margin: 0;
      padding: 0;
      outline: none;
      svg {
        height: 14px;
        stroke: ${({theme}) => theme.input.iconColor};
      }
      &:hover, &:focus {
        svg {
          stroke: ${({theme}) => theme.brand.primary} !important;
        }
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }
  .react-calendar {
    border: 1px solid ${({theme}) => theme.brand.primarySoft};
    background-color: ${({theme}) => theme.menu.background};
    color: ${({theme}) => theme.text.primary};
    font-family: inherit;
    .react-calendar__navigation__arrow,
    .react-calendar__navigation__label,
    .react-calendar__tile {
      color: ${({theme}) => theme.text.primary};
    }
    .react-calendar__month-view__weekdays__weekday {
      color: ${({theme}) => theme.text.secondary};
    }
    .react-calendar__month-view__days__day--weekend {
      color: ${({theme}) => theme.state.danger};
    }
    .react-calendar__month-view__days__day--neighboringMonth {
      color: ${({theme}) => theme.text.muted};
    }
    .react-calendar__tile:disabled {
      color: ${({theme}) => theme.text.muted};
      background-color: ${({theme}) => theme.surface.subtle};
    }
    .react-calendar__navigation__arrow,
    .react-calendar__navigation__label,
    .react-calendar__tile {
      &:hover {
        color: ${({theme}) => theme.text.inverse};
        background-color: ${({theme}) => theme.brand.primary};
      }
    }
    .react-calendar__tile--now, .react-calendar__tile--active {
      color: ${({theme}) => theme.text.inverse};
    }
    .react-calendar__tile--now {
      background-color: ${({theme}) => theme.brand.primarySoft};
    }
    .react-calendar__tile--active {
      color: ${({theme}) => theme.text.inverse};
      background-color: ${({theme}) => theme.brand.primary};
    }
    .react-calendar__tile--hasActive {
      color: ${({theme}) => theme.text.inverse};
      background-color: ${({theme}) => theme.brand.primary};
    }
    &.react-calendar--selectRange .react-calendar__tile--hover {
      background-color: ${({theme}) => theme.menu.hoverBackground};
    }
    .react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus {
      background-color:  ${({theme}) => theme.brand.primarySoft};
    }
    .react-calendar__navigation button[disabled] {
      background-color: inherit;
      opacity: 0.5;
    }
  }
  
  label {
    color: ${({theme}) => theme.input.labelColor};
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
`;